// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a7473912","821":"7381d73f"}[chunkId] + ".chunk.js";
};